import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import FocusLayout from 'layouts/FocusLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

const VERIFY_SYNDICATE_INVITE_LINK_MUTATION = gql(`
  mutation VerifySyndicateInviteLink($id: ID!) {
    verifySyndicateInviteLink(id: $id) {
      id
    }
  }
`);

const SyndicateInviteLinkPage: FC = () => {
  const navigate = useNavigate();
  const { syndicateInviteLinkId } = useParams<{ syndicateInviteLinkId: string }>() as {
    syndicateInviteLinkId: string;
  };

  const [verifySyndicateInviteLink, { loading, error, data }] = useMutation(
    VERIFY_SYNDICATE_INVITE_LINK_MUTATION,
    {
      variables: {
        id: syndicateInviteLinkId,
      },
    }
  );

  useEffect(() => {
    verifySyndicateInviteLink().then(data => {
      if (!data.data?.verifySyndicateInviteLink?.id) return;
      navigate(`/syndicate-invites/${data.data.verifySyndicateInviteLink.id}`);
    });
  }, [navigate, verifySyndicateInviteLink]);

  const renderContent = () => {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} />;

    return <div>{data && <p>Redirecting to syndicate ...</p>}</div>;
  };

  return <FocusLayout>{renderContent()}</FocusLayout>;
};

export default SyndicateInviteLinkPage;
